import apiSlice from './api-slice';

export const settingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: (params) => ({
        url: '/booking/setting/list',
        method: 'GET',
        params: params
      }),
      providesTags: ['Setting']
    }),
    getConfigSettings: builder.query({
      query: (params) => ({
        url: '/booking/setting/config',
        method: 'GET',
        params: params
      }),
      providesTags: ['Setting']
    }),
    getSettingByKey: builder.query({
      query: (key) => ({
        url: `/booking/setting/key/${key}`,
        method: 'GET'
      }),
      providesTags: ['Setting']
      // providesTags: (result) => {
      //   return result ? [...result.settings.map(({ id }) => ({ type: 'Setting', id })), 'Setting'] : ['Setting'];
      // }
    }),
    addSetting: builder.mutation({
      query: (params) => ({
        url: `/booking/setting/`,
        method: 'POST',
        body: params
      }),
      // invalidatesTags: (result, error, arg) => [{ type: 'Car', id: result.car_brands.id }],
      // invalidatesTags: (result) => (result ? ['Setting'] : [])
      providesTags: ['Setting']
    }),
    editSettingByKey: builder.mutation({
      query: ({ key, ...params }) => ({
        url: `/booking/setting/key/${key}`,
        method: 'PUT',
        body: params
      }),
      // invalidatesTags: (result, error, arg) => [{ type: 'Car', id: result.car_brands.id }],
      // invalidatesTags: (result) => (result ? ['Setting'] : [])
      providesTags: ['Setting']
    })
  }),
  overrideExisting: false
});

export const {
  useGetSettingsQuery,
  useGetConfigSettingsQuery,
  useGetSettingByKeyQuery,
  useAddSettingMutation,
  useEditSettingByKeyMutation
} = settingApi;
